var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCinema(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_4648_9781)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4648_9781",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4648_9781",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4648_9781",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAClklEQVR4nO2cvW7UQBDH3fBRI4JESA89bSLvRAfiBajpIqR4JoQiV/IMVLwIvAKQCpB4CwqEjibcrCZaopMOpIv8cWuvvf+fNFKaS7w/j//r7K22KAAAAAAAAAAAAAAywl6Ut1XciYo7V3a/vZChyIILZfqslRPjZ7e6SeZyT9l9g1i6trlU3Nfgqn0nQ7I1k92is0NcoJOpUUwqE7cRfQ7R1Ey00KcWomkB0dRU9KKx6E2/rMtn/Ugqth+IFog2dDSiwxAdgoy2oSc8TIYC0Xi9WwOvdzKR6EBR55sE0dLP0wDRMnHRyu5CxZ3Z8WzXeH8n/KxMP8cYU6mLnv//94Nwz+6ditOh5U1GtL06uL/pOqwqH3l2H7ITHeMmFTVYVuVM2X1PRdZkRQfs6PENFTpSph8QHVH0Cjt9escLvVWmJTo6Zq5Fzu8i9+joK7+LGmQpetv5XdQgW9HbzO+iBtmLXmEn9NALvYdoidPR28jvJDo6RhWRucpvd6ZCf5Iby5RErwiykxvLFEXb6/JucmOZpGje30luLFMUrezmyY1lcpMhu3mstZEoort81g8gerSvd2MRbR0WnLqMMRvRhn/BKapoLCr10NFLLJPGjQ7Dwn/cjDZ8lRV3MjR8ORtf9DK37QYxyo5nu5uuI9sNNDFKsSWsN9EXQfbfTY4vn9zDJscEHk2feCUdHX5CBdEyMtE5PA1FZD8QLRBt6GhEhyE6BBltQ094mAwFovF6twZe72Rk0YHj2KjxDVJxv1qIxgGDvpcDBisnKUxMfkSlclg1Fh0ONA0Hmw598X4kpUxf7M3zm41FX8ku9yCb6kk+PXzQSvI/nc3EIX8wQdJaTNBC2X0McdG6kwEAAAAAAAAAAACKcXIJgl/PIbOP+PoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCinema);
export default __webpack_public_path__ + "static/media/icon-cinema.7449b52dc3f407e7e68d5968edd13cb8.svg";
export { ForwardRef as ReactComponent };